/**
 * Ausgleichsbetrag (einmaliger Betrag für einen Monat) — MIT Kommentar.
 *
 *   POST /v2/admin/users/{id}/bonus
 *
 * Ersetzt in CRM 2.0 `v1Users.createBonus` (POST /v1/admin/user/{id}/bonus):
 * v1 speichert den Kommentar nicht, deshalb war er nach dem Anlegen weder in
 * der Liste noch in der aktuellen Anzeige zu sehen.
 */
import { apiV2 } from './api';

export interface PriceBonusRow {
  id?: number;
  user_id?: number;
  /** Monatserster des Monats, für den der Betrag gilt (YYYY-MM-DD…). */
  gueltig_fuer: string;
  bonus: number | string;
  kommentar?: string | null;
  created_at?: string;
  updated_at?: string;
  [key: string]: unknown;
}

export interface PriceBonusCreateResult {
  bonus: PriceBonusRow;
  /** Alle Ausgleichsbeträge des Users, neueste zuerst. */
  boni: PriceBonusRow[];
}

export const v2PriceBonus = {
  /** Legt einen Ausgleichsbetrag an. `gueltig_fuer`: YYYY-MM oder YYYY-MM-DD. */
  create: async (
    userId: number,
    payload: { gueltig_fuer: string; bonus: string | number; kommentar?: string | null },
  ): Promise<PriceBonusCreateResult> => {
    const res = await apiV2.post<{ data: PriceBonusRow; meta: { boni?: PriceBonusRow[] } }>(
      `/admin/users/${userId}/bonus`,
      payload,
    );
    return { bonus: res.data.data, boni: res.data.meta?.boni ?? [res.data.data] };
  },
};

/** Fehlertext aus dem v2-Envelope (Validierung/`errors[0].message`) oder Fallback. */
export function priceBonusErrorMessage(err: unknown, fallback: string): string {
  const data = (err as { response?: { data?: { errors?: unknown; message?: string } } })?.response?.data;
  const errors = data?.errors;
  if (Array.isArray(errors) && typeof (errors[0] as { message?: string })?.message === 'string') {
    return (errors[0] as { message: string }).message;
  }
  if (errors && typeof errors === 'object') {
    const first = Object.values(errors as Record<string, unknown>)[0];
    if (Array.isArray(first) && typeof first[0] === 'string') return first[0];
  }
  return data?.message ?? (err instanceof Error && err.message ? err.message : fallback);
}
